const getRandomNumber = (max, currentNumber) => {
  const number = Math.floor(Math.random() * max);
  if (currentNumber === number) {
    return getRandomNumber(max, currentNumber);
  }
  return number;
};

export default getRandomNumber;
